<template>
  <div class="drugstore-api-keys-stage">
    <div>
      <div class="row top-space">
        <div class="top-space">
          <div class="mb-3 windows-like-breadcrumb-card shadow-sm">
            <DrugstoreApiKeysList />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DrugstoreApiKeysList from "./DrugstoreApiKeysList.vue";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";

export default {
  name: "DrugstoreApiKeysStage",
  components: {
    DrugstoreApiKeysList,
  },
  computed: {
    simplepharmAuth() {
      return useSimplepharmAuthModule();
    },
    commonModule() {
      return useCommonAppModule();
    },
  },
  mounted() {
    this.commonModule.setHorizontalNavbarTitle(`<i class="bx bx-key me-1"></i> Klucze API aptek`);
  },
  created() {
    this.simplepharmAuth.refreshToken().then(() => {
      this.commonModule.httpGetLicensedFeatures();
      this.commonModule.httpGetWorkingProfile();
    });
  },
};
</script>

<style scoped>
.drugstore-api-keys-stage {
  margin-left: 16px;
  margin-right: 16px;
}

.top-space {
  padding-top: 8px;
}
</style>
